var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F3BA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0743 25.15L27.9921 18.2322L34.9132 25.153L38.9383 21.1278L27.9921 10.1819L17.0495 21.1245L21.0744 25.1497L21.0743 25.15ZM10.1818 27.9922L14.2071 23.9664L18.2321 27.9914L14.2068 32.0166L10.1818 27.9922ZM21.0743 30.8349L27.9921 37.7523L34.913 30.8316L38.9403 34.8546L38.9383 34.8567L27.9921 45.8025L17.0495 34.8599L17.0438 34.8542L21.0747 30.8345L21.0743 30.8349ZM37.7521 27.9939L41.7774 23.9686L45.8023 27.9936L41.7772 32.0189L37.7521 27.9939Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0734 27.9899H32.0752L27.991 23.9055L24.9723 26.9234L24.6255 27.2704L23.9102 27.9858L23.9045 27.9913L23.9102 27.9972L27.991 32.0786L32.0754 27.9942L32.0774 27.9919L32.0737 27.9899",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.f9860b7f.svg";
export { ForwardRef as ReactComponent };